import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { MultiSelect } from "../bundles-multi-select";
import { useActiveBundles } from "@/features/coupons/hooks/use-active-bundles";
import { Bundle } from "@/pages/bundles/types/bundle";
import { FormWizardData } from "./wizard-form";

export default function StepLinks({
  form,
}: {
  form: UseFormReturn<FormWizardData>;
}) {
  const { data: bundleData, isLoading } = useActiveBundles();
  const options = (bundleData?.bundles ?? []).map((b: Bundle) => ({
    label: b.name,
    value: b.id,
  }));

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="bundle_ids"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Bundles</FormLabel>
            <FormControl>
              <MultiSelect
                options={options}
                value={field.value}
                onChange={field.onChange}
                isLoading={isLoading}
                placeholder="Select bundles"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="doc_link"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Doc Link (optional)</FormLabel>
            <FormControl>
              <Input
                placeholder="https://…"
                {...field}
                value={field.value ?? ""}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
